import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { PRODUCT_IMAGES } from 'src/app/helpers/google-storage.helper';
import { ORDER_CATEGORY } from 'src/app/helpers/order-categories.helper';
import Utils from 'src/app/helpers/utils.helper';
import { CartItemsTotal } from 'src/app/models/cart-items-total.model';
import { ProductDataSubject } from 'src/app/models/product-data-subject.model';
import { CartItemsRequest } from 'src/app/models/requests/cart-items-request.model';
import { CartManagerService } from 'src/app/services/local/cart-manager.service';

@Component({
    selector: 'app-product-data',
    templateUrl: './product-data.component.html',
    styleUrls: ['./product-data.component.scss'],
    standalone: false
})
export class ProductDataComponent implements OnInit {

  @Input() productCategory: any | undefined;

  public currentTempItems: CartItemsRequest[] | undefined;
  public productData:  {
    imageUrl?: string | undefined;
    description: string;
    brand: string | undefined;
  } | undefined;
  public cartItemTotal: any;
  public isEditMode: boolean = false;

  @Input() tempCartEvents: Observable<ProductDataSubject> | undefined;

  constructor(private _cartManagerService: CartManagerService,
              private _route: ActivatedRoute) {}

  ngOnInit(): void {
    this._route.queryParams
    .subscribe(params => {
      this.isEditMode = params.isEditMode === 'true';
      this.getProductFromLocalStorage();
      if (this.tempCartEvents) {
        this.tempCartEvents.subscribe((subjectData) => {
          if (subjectData) {
            if (subjectData.status == 'accessory-stage') {
              this.getProductFromLocalStorage(true)
            }
            else {
              this.getProductFromLocalStorage(false);
            }
          }         
        });
      }
    });
  }

  getProductFromLocalStorage(isAccessoryStage: boolean = false) {
    if (!isAccessoryStage) {
      let cartItem = this._cartManagerService.getTempCartItem();
      if (cartItem) {
          this.currentTempItems = [cartItem];
      }
    }
    else {
      this.currentTempItems = this._cartManagerService.getTempAccessoryCartItems();
    }

    this.setMainProductDetails(isAccessoryStage);

    if (this.currentTempItems) {
      this._cartManagerService.calculateCart(this.currentTempItems, this.isEditMode)
      .subscribe((data: CartItemsTotal) => {
        this.cartItemTotal = data;
      }, (error) => {
        console.log(error);
      });
    }
    else {
      this.cartItemTotal = this._cartManagerService.getCart()
      .subscribe((data: CartItemsTotal) => {
        this.cartItemTotal = data;
      }, (error) => {
        console.log(error);
      });
    }
  }

  setMainProductDetails(isAccessoryStage: boolean = false) {
    if (!isAccessoryStage) {
      if (this.currentTempItems) {
        let mainItem = this.currentTempItems[0];
        this.productData = {
          description: mainItem.itemDescription,
          imageUrl: this.getImageUrl(mainItem.itemCategory, mainItem.itemImageName),
          brand: ''
        }
      }
    }
    else {
      let newCartItemRef = this._cartManagerService.getNewCartItemRef();
      if (newCartItemRef) {
        const imageName = Utils.getImageFromLegacyPath(newCartItemRef.itemImageName) || '';
        this.productData = {
          description: newCartItemRef.itemDescription,
          imageUrl: this.getImageUrl(newCartItemRef.itemCategory, imageName),
          brand: ''
        }
      }
    }
  }

  getImageUrl(itemCategory: string, itemImageName: string | undefined) {
    let imageUrl: string | undefined;
    if (itemCategory == ORDER_CATEGORY.glasses) {
      imageUrl = `${PRODUCT_IMAGES.safetyGlasses}${itemImageName}`
    }
    else if (itemCategory == ORDER_CATEGORY.computerGlasses) {
      imageUrl = `${PRODUCT_IMAGES.safetyGlasses}${itemImageName}`
    }
    else if (itemCategory == ORDER_CATEGORY.dressGlasses) {
      imageUrl = `${PRODUCT_IMAGES.dressGlasses}${itemImageName}`
    }
    else if (itemCategory == ORDER_CATEGORY.respiratorInserts) {
      imageUrl = `${PRODUCT_IMAGES.respiratorInserts}${itemImageName}`
    }
    return imageUrl;
  }

}
